import { render, staticRenderFns } from "./previewFileModel.vue?vue&type=template&id=6f9b681f"
import script from "./previewFileModel.vue?vue&type=script&lang=js"
export * from "./previewFileModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9b681f')) {
      api.createRecord('6f9b681f', component.options)
    } else {
      api.reload('6f9b681f', component.options)
    }
    module.hot.accept("./previewFileModel.vue?vue&type=template&id=6f9b681f", function () {
      api.rerender('6f9b681f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/previewFile/previewFileModel.vue"
export default component.exports